import { useState, useEffect } from 'react';
import { useAccessibility } from '../../../context/AccessibilityContext/AccessibilityContext';
import Block from '../../../components/Block/Block';
import YandexMap from '../../../components/YandexMap/YandexMap';
import FadeIn from '../../../components/FadeIn/FadeIn';
import style from './contactsblock.module.scss';

const ContactsBlock = () => {
    const [isMobile, setIsMobile] = useState(false);
    const { settings: { contrast } } = useAccessibility();

    useEffect(() => {
        const checkScreenSize = () => {
            setIsMobile(window.innerWidth <= 992);
        };

        checkScreenSize();
        window.addEventListener('resize', checkScreenSize);
        return () => window.removeEventListener('resize', checkScreenSize);
    }, []);

    const mapCenter = [45.105606, 38.979427]

    return (
        <Block
            flexDirection='column'
            justifyContent='center'
            alignItems='start'
            width={isMobile ? '100%' : '75%'}
            height='fit-content'
            background={contrast !== 'default' ? 'var(--bg-primary)' : 'rgba(255, 255, 255, 0.92)'}
            header="КОНТАКТЫ"
        >
            <FadeIn>
                <div className={style.content}>
                    <div className={style.left}>
                        <div className={style.contactItem}>
                            <span className={style.label}>Адрес</span>
                            <span className={style.value}>Краснодар, ул. Конгрессная 2а</span>
                        </div>
                        
                        <div className={style.contactItem}>
                            <span className={style.label}>Телефон</span>
                            <a href="tel:+78619905510" className={style.value}>
                                +7 (861) 990-55-10
                            </a>
                        </div>
                        
                        <div className={style.contactItem}>
                            <span className={style.label}>График работы</span>
                            <span className={style.value}>
                                Пн-Пт: 09:00 – 19:00
                            </span>
                        </div>
                    </div>
                    
                    <div className={style.right}>
                        <YandexMap
                            width='100%'
                            height='500px'
                            center={mapCenter}
                        />
                    </div>
                </div>
            </FadeIn>
        </Block>
    );
};

export default ContactsBlock;